import React, { Component } from "react";
import PropTypes from "prop-types";
import withLogFeatureUsage from "../../containers/AnalyticContainer";

class TrackedLink extends Component {
	render() {
		const LoggingLink = ({ onClick, children }) => {
			return <span onClick={onClick}>{children}</span>;
		};
		const ComponentWithLink = withLogFeatureUsage(LoggingLink, this.props.featureType, this.props.destId, this.props.srcId);

		return (
			<ComponentWithLink>
				{this.props.children}
			</ComponentWithLink>
		);
	}
}

TrackedLink.propTypes = {
	featureType: PropTypes.object.isRequired,
	destId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
	srcId: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
}

export default TrackedLink;



// WEBPACK FOOTER //
// ./src/react/views/generic/TrackedLink.jsx